/**
 * @description
 * System service for managing system health and metrics.
 *
 * @author AI Developer <ai@byteable.ai>
 * @date January 8, 2025
 */

import { BaseAPIClient } from "../core/base-client";
import type { SystemMetrics, HealthStatus } from "./types";

/**
 * System service for managing system operations
 */
export class SystemService extends BaseAPIClient {
  /**
   * Get system metrics
   */
  async getMetrics(): Promise<SystemMetrics> {
    return this.request<SystemMetrics>("/metrics");
  }

  /**
   * Get health status
   */
  async getHealth(): Promise<HealthStatus> {
    return this.request<HealthStatus>("/health");
  }
}

// Export singleton instance
export const systemService = new SystemService();
